(() => {
function initialize(root) {
 if(root.dataset.ready) return;
 root.dataset.ready='true';
 const grid=root.querySelector('.cv-era__products');
 const cards=[...grid.children];
 const sort=root.querySelector('[data-era-sort]');
 const filter=root.querySelector('[data-era-availability]');
 const count=root.querySelector('[data-era-count]');
 const noun=count.textContent.trim().replace(/^\d+\s*/, '');
 cards.forEach((card,index)=>card.dataset.originalIndex=index);
 function update() {
  const ordered=[...cards].sort((a,b)=>{
   const stock=Number(b.dataset.available==='true')-Number(a.dataset.available==='true');
   if(stock) return stock;
   if(sort.value==='price-ascending') return Number(a.dataset.price)-Number(b.dataset.price);
   if(sort.value==='price-descending') return Number(b.dataset.price)-Number(a.dataset.price);
   if(sort.value==='title') return a.dataset.title.localeCompare(b.dataset.title);
   return Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex);
  });
  let shown=0;
  for(const card of ordered){card.hidden=filter.value!=='all'&&card.dataset.available!==filter.value;if(!card.hidden)shown++;grid.append(card);}
  count.textContent=shown+' '+noun;
 }
 sort.addEventListener('change',update);
 filter.addEventListener('change',update);
}
 document.querySelectorAll('[data-vault-era]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-vault-era]').forEach(initialize));
})();
